/**
 * Tough-Bar Builder - State Module
 * All reactive state variables
 */
window.ToughBarBuilder = window.ToughBarBuilder || {};

window.ToughBarBuilder.state = () => ({
  // Core state
  loading: false,
  error: null,
  response: {},
  _builderApiRequestSeq: 0,
  context: {},
  localKit: {}, // Stores device kit locally before API call
  sharedConfigIdFromUrl: null,
  currentSharedConfigId: null,
  stepSnapshotIds: {},
  _snapshotSyncRequestSeq: 0,
  snapshotSuppressUrlUpdates: false,
  popstateHandlerBound: false,
  shareLoading: false,
  shareCopied: false,

  // UI state
  modal: { open: false, type: null },
  modalTriggerEl: null,
  pricingExpanded: false,
  headerStockWarningOpen: false,
  toughBarExpanded: true,
  deviceExpanded: true,

  // Product data
  products: {},
  quantities: {},
  removedProducts: [],
  excludedProducts: [],
  failedImages: [],

  // Notify modal state
  notifyEmail: '',
  notifyMarketing: true,
  notifyLoading: false,
  notifySuccess: false,
  notifyEmailError: false,

  // Accessories state (Step 3)
  accessoriesExpanded: true,
  accessoryButtonsExpanded: false,
  selectedAccessories: [], // Array of selected accessory objects { id, config }
  accessoryModal: {
    accessoryId: null,
    make: '',
    model: '',
    case_type: ''
  },
  accessoryCustomization: null,
  accessoryCustomizeSelections: {},
  accessoryCustomizeLoading: false,
  accessoryCustomizeError: null,
  accessoryCustomizeTarget: null,
  accessoryCustomizeSignature: null,
  accessoryCustomizePrimarySelectionBackup: null,
  accessoryCustomizeAvailability: {},
  accessoryButtonsCache: [],
  _accessoryRequestTokens: {},
  _accessorySnapshotRefreshInFlight: false,
  _accessorySnapshotRefreshPending: false,

  // Customize modal state
  customization: null,
  customizeSelections: {},
  customizePrices: {},
  customizeLoading: false,
  customizeError: null,
  customizeTarget: null,
  customizeApplied: false,
  customizeTabletSignature: null,
  customizeTabletSelectionBackup: null,
  customizeContextBackup: null,
  pendingCustomizeContextRestore: null,

  // Tablet modal state (for cancel/restore)
  tabletSelectionBackup: null,
  tabletSelectionSignature: null,
  tabletSelectionConfirmed: null,
  tabletOptionsCache: null,
  restoringTabletSelection: false,

  // Preview modal
  previewModal: null,

  // Shared body scroll lock
  bodyScrollLockOwners: {},
  bodyScrollLockPosition: undefined,

  // Side cart (mobile drawer)
  sideCartDrawerOpen: false,
  sideCartCollapsed: true,
});
